// prayerReducer.js
import * as actionTypes from "../ActionTypes";

const initialState = {
  creating: false,
  success: false,
  error: null,
  // New state for user's prayer requests
  myPrayerRequests: [],
  fetchingRequests: false,
  fetchRequestsError: null,
  requestsFetched: false,
  responsesLoading: false,
responsesError: null,
prayerResponses: [],
myPrayersList: [],
prayersPagination: {
  page: 1,
  limit: 10,
  total: 0,
},
prayersListLoading: false,
prayersListError: null,
churchFollowersPrayers: [],
churchFollowersPagination: {
  page: 1,
  limit: 10,
  total: 0,
},
churchFollowersLoading: false,
churchFollowersError: null,
channelFollowersPrayers: [],
channelFollowersPagination: {
  page: 1,
  limit: 10,
  total: 0,
},
channelFollowersLoading: false,
channelFollowersError: null,

ministriesFollowersPrayers: [],
ministriesFollowersPagination: {
  page: 1,
  limit: 10,
  total: 0,
},
ministriesFollowersLoading: false,
ministriesFollowersError: null,


};

const prayerReducer = (state = initialState, action) => {
  switch (action.type) {
    // Existing cases
    case actionTypes.PRAYER_REQUEST_CREATE_REQUEST:
      return {
        ...state,
        creating: true,
        success: false,
        error: null,
      };

    case actionTypes.PRAYER_REQUEST_CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        success: true,
      };

    case actionTypes.PRAYER_REQUEST_CREATE_FAIL:
      return {
        ...state,
        creating: false,
        success: false,
        error: action.payload,
      };

    // New cases for fetching user's prayer requests
    case actionTypes.MY_PRAYER_REQUESTS_FETCH_REQUEST:
      return {
        ...state,
        fetchingRequests: true,
        fetchRequestsError: null,
        requestsFetched: false,
      };

    case actionTypes.MY_PRAYER_REQUESTS_FETCH_SUCCESS:
      return {
        ...state,
        fetchingRequests: false,
        myPrayerRequests: action.payload,
        requestsFetched: true,
      };

    case actionTypes.MY_PRAYER_REQUESTS_FETCH_FAIL:
      return {
        ...state,
        fetchingRequests: false,
        fetchRequestsError: action.payload,
        requestsFetched: false,
      };
      case actionTypes.PRAYER_RESPONSE_READ_REQUEST:
case actionTypes.PRAYER_RESPONSE_CREATE_REQUEST:
case actionTypes.PRAYER_RESPONSE_UPDATE_REQUEST:
case actionTypes.PRAYER_RESPONSE_DELETE_REQUEST:
  return {
    ...state,
    responsesLoading: true,
    responsesError: null,
  };

case actionTypes.PRAYER_RESPONSE_READ_SUCCESS:
  return {
    ...state,
    responsesLoading: false,
    prayerResponses: action.payload,
  };

case actionTypes.PRAYER_RESPONSE_CREATE_SUCCESS:
case actionTypes.PRAYER_RESPONSE_UPDATE_SUCCESS:
case actionTypes.PRAYER_RESPONSE_DELETE_SUCCESS:
  return {
    ...state,
    responsesLoading: false,
  };

case actionTypes.PRAYER_RESPONSE_READ_FAIL:
case actionTypes.PRAYER_RESPONSE_CREATE_FAIL:
case actionTypes.PRAYER_RESPONSE_UPDATE_FAIL:
case actionTypes.PRAYER_RESPONSE_DELETE_FAIL:
  return {
    ...state,
    responsesLoading: false,
    responsesError: action.payload,
  };

  case actionTypes.MY_PRAYERS_LIST_FETCH_REQUEST:
    return {
      ...state,
      prayersListLoading: true,
      prayersListError: null,
    };
  
  case actionTypes.MY_PRAYERS_LIST_FETCH_SUCCESS:
    return {
      ...state,
      prayersListLoading: false,
      myPrayersList: action.payload.data,
      prayersPagination: action.payload.pagination,
    };
  
  case actionTypes.MY_PRAYERS_LIST_FETCH_FAIL:
    return {
      ...state,
      prayersListLoading: false,
      prayersListError: action.payload,
    };
    case actionTypes.CHURCH_FOLLOWERS_PRAYERS_FETCH_REQUEST:
      return {
        ...state,
        churchFollowersLoading: true,
        churchFollowersError: null,
      };
    
    case actionTypes.CHURCH_FOLLOWERS_PRAYERS_FETCH_SUCCESS:
      return {
        ...state,
        churchFollowersLoading: false,
        churchFollowersPrayers: action.payload.data,
        churchFollowersPagination: action.payload.pagination,
      };
    
    case actionTypes.CHURCH_FOLLOWERS_PRAYERS_FETCH_FAIL:
      return {
        ...state,
        churchFollowersLoading: false,
        churchFollowersError: action.payload,
      };
    // CHANNEL FOLLOWERS
case actionTypes.CHANNEL_FOLLOWERS_PRAYERS_FETCH_REQUEST:
  return {
    ...state,
    channelFollowersLoading: true,
    channelFollowersError: null,
  };

case actionTypes.CHANNEL_FOLLOWERS_PRAYERS_FETCH_SUCCESS:
  return {
    ...state,
    channelFollowersLoading: false,
    channelFollowersPrayers: action.payload.data,
    channelFollowersPagination: action.payload.pagination,
  };

case actionTypes.CHANNEL_FOLLOWERS_PRAYERS_FETCH_FAIL:
  return {
    ...state,
    channelFollowersLoading: false,
    channelFollowersError: action.payload,
  };

// MINISTRIES FOLLOWERS
case actionTypes.MINISTRIES_FOLLOWERS_PRAYERS_FETCH_REQUEST:
  return {
    ...state,
    ministriesFollowersLoading: true,
    ministriesFollowersError: null,
  };

case actionTypes.MINISTRIES_FOLLOWERS_PRAYERS_FETCH_SUCCESS:
  return {
    ...state,
    ministriesFollowersLoading: false,
    ministriesFollowersPrayers: action.payload.data,
    ministriesFollowersPagination: action.payload.pagination,
  };

case actionTypes.MINISTRIES_FOLLOWERS_PRAYERS_FETCH_FAIL:
  return {
    ...state,
    ministriesFollowersLoading: false,
    ministriesFollowersError: action.payload,
  };

    default:
      return state;
  }
};

export default prayerReducer;